<template>
  <article class="wx-article" :lang="isEnglish ? 'en' : 'zh-CN'">
    <div class="wx-inner">
      <h1 class="wx-title">{{ article.title }}</h1>
      <template v-for="(block, index) in article.blocks" :key="index">
        <div
          v-if="block.type === 'image'"
          class="wx-media"
          :class="block.align === 'center' ? 'is-center' : 'is-left'"
          :style="{ marginBottom: block.mb + 'px' }"
        >
          <img
            :src="block.src"
            :alt="article.title"
            :class="{ 'is-full': !block.width }"
            :style="block.width ? { width: block.width + 'px' } : null"
            loading="lazy"
          />
        </div>
        <p v-else-if="block.type === 'blank'" class="wx-blank" :style="blockStyle(block)"><br /></p>
        <p v-else-if="block.type === 'p'" class="wx-p" :style="blockStyle(block)">
          <span v-for="(seg, si) in block.segs" :key="si" :class="seg.c">
            <a v-if="seg.u" :href="seg.u" target="_blank" rel="noopener noreferrer">{{ seg.t }}</a>
            <template v-else>{{ seg.t }}</template>
          </span>
        </p>
        <component
          :is="block.ordered === false ? 'ul' : 'ol'"
          v-else-if="block.type === 'list'"
          class="wx-list"
        >
          <li v-for="(item, ii) in block.items" :key="ii">
            <p class="wx-p">
              <span v-for="(seg, si) in item" :key="si" :class="seg.c">
                <a v-if="seg.u" :href="seg.u" target="_blank" rel="noopener noreferrer">{{ seg.t }}</a>
                <template v-else>{{ seg.t }}</template>
              </span>
            </p>
          </li>
        </component>
      </template>
    </div>
  </article>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const isEnglish = computed(() => locale.value === "en");

const content = {
  "zh": {
    "title": "D2Pi-2.0 超高通量无细胞蛋白质合成筛选平台上线，面向全社会开放预约！",
    "blocks": [
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-6.png",
        "width": null,
        "align": "center",
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-1.png",
        "width": null,
        "align": "center",
        "mb": 0
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-7.png",
        "width": null,
        "align": "center",
        "mb": 20
      },
      {
        "type": "blank"
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-2.png",
        "width": 255,
        "align": "left",
        "mb": 16
      },
      {
        "type": "p",
        "segs": [
          {
            "t": "D2Pi-2.0 超高通量无细胞蛋白质筛选平台是围绕康码生物自研的D2P无细胞蛋白质合成（Cell-free Protein Synthesis，CFPS）技术开发的全自动、高通量蛋白质智造系统。最高设计通量为10000，即",
            "c": ""
          },
          {
            "t": "每24小时可以完成10000种蛋白质分子的合成",
            "c": "hl"
          },
          {
            "t": "。该系统由无细胞蛋白质合成相关步骤的处理工作站（比如，核酸提取工作站、模板扩增工作站、无细胞蛋白合成工作站、蛋白纯化工作站和荧光检测工作站等）、机械臂、机器人和调度系统等组成。整个系统由康码自主设计并开发。",
            "c": ""
          }
        ],
        "mb": 16
      },
      {
        "type": "blank",
        "mt": 8,
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-3.png",
        "width": 250,
        "align": "left",
        "mb": 16
      },
      {
        "type": "p",
        "segs": [
          {
            "t": "D2Pi-2.0 超高通量无细胞蛋白质筛选平台已于 2026 年4月正式对外开放，面向全社会提供服务，承接各类蛋白质设计与高通量筛选需求。",
            "c": ""
          },
          {
            "t": "服务面向有多种目标蛋白质、需要快速完成表达情况验证和初步筛选的客户",
            "c": "hl"
          },
          {
            "t": "，如科研院所、高校实验室、AI 企业、生物制药、生物制造、生物技术公司及学校等多类用户群体。平台目前已服务于生物医药 AI 设计、生物制造、食品健康、创新药研发等多个领域的企业与科研机构，持续响应各类蛋白质高通量筛选研发需求，全面向全社会开放共享。",
            "c": ""
          }
        ],
        "mb": 16
      },
      {
        "type": "blank",
        "mt": 8,
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-4.png",
        "width": 250,
        "align": "left",
        "mb": 16
      },
      {
        "type": "p",
        "segs": [
          {
            "t": "D2Pi-2.0 全自动无细胞蛋白质智造系统，相较传统细胞底盘的表达系统优势明显：",
            "c": ""
          }
        ],
        "mb": 8
      },
      {
        "type": "list",
        "ordered": true,
        "items": [
          [
            {
              "t": "康码生物自研的D2P无细胞蛋白合成技术，来源于",
              "c": ""
            },
            {
              "t": "真核体系",
              "c": "hl"
            },
            {
              "t": "，能够合成多种不同类型的蛋白质，且不受细胞限制，特别适合AI设计蛋白、具有细胞毒性蛋白等细胞体系难表达蛋白的合成，可以探索更广阔的蛋白质序列潜在空间；",
              "c": ""
            }
          ],
          [
            {
              "t": "每天最高达10000种蛋白质的合成通量，特别适用于AI for Science下游湿实验验证，与AI干实验的最佳匹配；",
              "c": ""
            }
          ],
          [
            {
              "t": "借助无细胞蛋白质合成的高效，最快一周即可实现一轮蛋白设计的实验合成和验证，更快获得反馈数据，完成",
              "c": ""
            },
            {
              "t": "“干湿实验闭环”",
              "c": "hl"
            },
            {
              "t": "，加速算法训练迭代，提高研发效率和成功率。",
              "c": ""
            }
          ]
        ]
      },
      {
        "type": "blank",
        "mt": 8,
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-5.png",
        "width": 254,
        "align": "left",
        "mb": 16
      },
      {
        "type": "list",
        "ordered": true,
        "items": [
          [
            {
              "t": "登录 ",
              "c": ""
            },
            {
              "t": "https://www.d2plab.com/d2pi/",
              "c": "hl u",
              "u": "https://www.d2plab.com/d2pi/"
            },
            {
              "t": "注册并填写配置及联系方式提交申请（点击链接可快捷跳转）；",
              "c": ""
            }
          ],
          [
            {
              "t": "康码生物技术人员后续会向您回访并沟通项目具体信息，专人专项全程协助；",
              "c": ""
            }
          ],
          [
            {
              "t": "通过康码生物自主研发的D2PLab软件使用D2Pi-2.0服务。下载并登录D2PLab后，即可通过D2PLab将您希望合成的蛋白质序列直接发送到D2Pi-2.0的管理后台。",
              "c": ""
            }
          ]
        ]
      },
      {
        "type": "blank",
        "mb": 8
      },
      {
        "type": "blank"
      }
    ]
  },
  "en": {
    "title": "D2Pi-2.0 Ultra-High-Throughput Cell-Free Protein Synthesis and Screening Platform Goes Live — Now Open for Reservations to the Public!",
    "blocks": [
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-6.png",
        "width": null,
        "align": "center",
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-1.png",
        "width": null,
        "align": "center",
        "mb": 0
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-7.png",
        "width": null,
        "align": "center",
        "mb": 30
      },
      {
        "type": "blank"
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-2.png",
        "width": 255,
        "align": "left",
        "mb": 16
      },
      {
        "type": "p",
        "segs": [
          {
            "t": "The D2Pi-2.0 ultra-high-throughput cell-free protein screening platform is a fully automated, high-throughput protein manufacturing system built on Healthcode Bio's independently developed D2P cell-free protein synthesis (Cell-free Protein Synthesis, CFPS) technology. Its maximum designed throughput is 10,000, meaning that ",
            "c": ""
          },
          {
            "t": "it can synthesize 10,000 kinds of protein molecules within 24 hours",
            "c": "hl"
          },
          {
            "t": ". The system consists of processing workstations for the steps related to cell-free protein synthesis (such as a nucleic acid extraction workstation, a template amplification workstation, a cell-free protein synthesis workstation, a protein purification workstation and a fluorescence detection workstation), robotic arms, robots and a scheduling system. The entire system was designed and developed independently by Healthcode Bio.",
            "c": ""
          }
        ],
        "mb": 16
      },
      {
        "type": "blank",
        "mt": 8,
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-3.png",
        "width": 250,
        "align": "left",
        "mb": 16
      },
      {
        "type": "p",
        "segs": [
          {
            "t": "The D2Pi-2.0 ultra-high-throughput cell-free protein screening platform officially opened to the public in April 2026, providing services to society at large and undertaking all kinds of protein design and high-throughput screening needs. It ",
            "c": ""
          },
          {
            "t": "serves customers who have multiple target proteins and need to quickly verify expression and carry out preliminary screening",
            "c": "hl"
          },
          {
            "t": ", including research institutes, university laboratories, AI companies, biopharmaceutical companies, biomanufacturing companies, biotechnology companies and schools. The platform currently serves enterprises and research institutions in fields such as biomedical AI design, biomanufacturing, food health and innovative drug development, continuously responding to high-throughput protein screening R&D needs and fully opening its capabilities to society.",
            "c": ""
          }
        ],
        "mb": 16
      },
      {
        "type": "blank",
        "mt": 8,
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-4.png",
        "width": 250,
        "align": "left",
        "mb": 16
      },
      {
        "type": "p",
        "segs": [
          {
            "t": "Compared with conventional cell-based expression systems, the fully automated D2Pi-2.0 cell-free protein manufacturing system offers clear advantages:",
            "c": ""
          }
        ],
        "mb": 8
      },
      {
        "type": "list",
        "ordered": true,
        "items": [
          [
            {
              "t": "Healthcode Bio's independently developed D2P cell-free protein synthesis technology is derived from a ",
              "c": ""
            },
            {
              "t": "eukaryotic system",
              "c": "hl"
            },
            {
              "t": ". It can synthesize many different types of proteins and is not limited by cells, making it especially suitable for AI-designed proteins and cytotoxic proteins that are hard to express in cell systems, and allowing exploration of a much broader space of potential protein sequences;",
              "c": ""
            }
          ],
          [
            {
              "t": "A synthesis throughput of up to 10,000 proteins per day, ideally suited to downstream wet-lab validation for AI for Science and a perfect match for AI dry-lab work;",
              "c": ""
            }
          ],
          [
            {
              "t": "Thanks to the efficiency of cell-free protein synthesis, one full round of experimental synthesis and validation of protein designs can be completed in as little as one week, delivering feedback data faster, closing the ",
              "c": ""
            },
            {
              "t": "“dry-wet lab loop”",
              "c": "hl"
            },
            {
              "t": ", accelerating algorithm training iterations and improving R&D efficiency and success rates.",
              "c": ""
            }
          ]
        ]
      },
      {
        "type": "blank",
        "mt": 8,
        "mb": 8
      },
      {
        "type": "image",
        "src": "https://www.healthcode.com/media/d2pi2.0/d2pi2.0-5.png",
        "width": 254,
        "align": "left",
        "mb": 16
      },
      {
        "type": "list",
        "ordered": true,
        "items": [
          [
            {
              "t": "Log in to ",
              "c": ""
            },
            {
              "t": "https://www.d2plab.com/d2pi/",
              "c": "hl u",
              "u": "https://www.d2plab.com/d2pi/"
            },
            {
              "t": " to register, fill in your configuration and contact details and submit your application (click the link to jump there directly);",
              "c": ""
            }
          ],
          [
            {
              "t": "Healthcode Bio's technical staff will then follow up with you to discuss the project details, with dedicated support throughout;",
              "c": ""
            }
          ],
          [
            {
              "t": "Use the D2Pi-2.0 service through D2PLab, the software independently developed by Healthcode Bio. After downloading and logging in to D2PLab, you can send the protein sequences you wish to synthesize directly to the D2Pi-2.0 management backend.",
              "c": ""
            }
          ]
        ]
      },
      {
        "type": "blank",
        "mb": 8
      },
      {
        "type": "blank"
      }
    ]
  }
};

// 还原原文里显式写出的上下间距（空行块、部分段落）
const blockStyle = (block) => ({
  marginTop: block.mt !== undefined ? block.mt + "px" : null,
  marginBottom: block.mb !== undefined ? block.mb + "px" : null,
});

const article = computed(() => (isEnglish.value ? content.en : content.zh));
</script>

<style scoped>
.wx-article {
  width: 100%;
  min-height: 100vh;
  padding: 8rem 0 4rem;
  background: #fff;
}

.wx-inner {
  max-width: 677px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  font-size: 17px;
  line-height: 1.75;
  letter-spacing: 0.034em;
  color: #333;
  text-align: justify;
  overflow-wrap: break-word;
}

.wx-title {
  margin: 0 0 24px;
  color: #222;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.4;
  text-align: left;
}

.wx-p {
  margin: 0 0 16px;
}

/* 原文用 <br> / &nbsp; 撑出的空行，保留一个行高的留白 */
.wx-blank {
  margin: 0;
  line-height: 1.75;
}

.wx-media {
  margin: 0 0 16px;
}

.wx-media.is-center {
  text-align: center;
}

.wx-media.is-left {
  text-align: left;
}

.wx-media img {
  display: inline-block;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

.wx-media img.is-full {
  width: 100%;
}

.wx-list {
  margin: 0 0 16px;
  padding-left: 1.75em;
  list-style-type: decimal;
}

.wx-list li > .wx-p {
  margin-bottom: 8px;
}

.wx-list li:last-child > .wx-p {
  margin-bottom: 0;
}

.hl {
  color: rgb(0, 128, 255);
  font-weight: bold;
}

.wx-inner a {
  color: inherit;
  text-decoration: inherit;
}

.b {
  font-weight: bold;
}

.u {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .wx-article {
    padding-top: 7rem;
  }

  .wx-inner {
    font-size: 16px;
  }

  .wx-title {
    font-size: 19px;
  }
}
</style>
